import { groupRoles as actionTypes } from "store/constants";
import { reduceIsFetching, fetchableInitialState } from "store/factories/fetchable";


const initialState = {
	...fetchableInitialState,
	content: {
		roles: [],
	},
};

export function groupRoleList(state = initialState, action) {
	switch (action.type) {
		case actionTypes.GROUP_ROLES_IS_FETCHING:
			return reduceIsFetching(state, action);
		case actionTypes.GROUP_ROLES_SET_ERROR:
			return {
				...state,
				error: action.payload,
			};
		case actionTypes.GROUP_ROLES_SET_DATA:
			return {
				...state,
				content: {
					...state.content,
          roles: action.payload,
				},
			};
		default:
			return state;
	}
}


